import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'    //格式化基础样式
import App from './App.vue'

import accounting from 'accounting'
Vue.prototype.$accounting = accounting;
Vue.filter("currency", function(value) { return Vue.prototype.$accounting.formatMoney(value, '') })
Vue.filter("Number", function(value) { return Vue.prototype.$accounting.formatNumber(value, '') })

//全局跳转路由
import router from './router'

//路由跳转检查,检查是否登录
import "./routercheck"

import store from './store'

Vue.use(ElementUI, {
	size: 'medium',
})

new Vue({
    el: '#app',
	store,
	router,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js